var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdderDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 15,
    viewBox: "0 0 40 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12L3 15V0H0V12Z",
    fill: "#1C1C1C",
    fillOpacity: 0.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 15,
    transform: "translate(3)",
    fill: "#1C1C1C",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5L20 10L27 5",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12L37 15L37 -2.62268e-07L40 0L40 12Z",
    fill: "#1C1C1C",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdderDown);
export default __webpack_public_path__ + "static/media/adder-down.fd6ee1fcb0099fadc482fe2ce5dff931.svg";
export { ForwardRef as ReactComponent };